import {
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import { useDispatch } from "react-redux";
import { loadHideAlert, loadLinkAlert } from "redux/reducers/top";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  studio: {
    "& .mySwiper": {
      height: "calc(100vh - 52px)",
      paddingBottom: 0,
      "& .swiper-wrapper": {
        "& .swiper-slide": {
          position: "relative",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          color: theme.palette.common.white,
          padding: `0 ${rem(44)}`,
          "& h2": {
            fontSize: rem(18),
            color: theme.palette.info.main,
            fontWeight: 700,
            lineHeight: rem(22),
            marginBottom: rem(8),
            zIndex: 1,
          },
          "& dl": {
            zIndex: 1,
            "& dt": {
              fontSize: rem(28),
              fontWeight: 800,
              lineHeight: rem(34),
              marginBottom: rem(20),
              "& span": {
                display: "block",
                fontWeight: 400,
              },
            },
            "& dd": {
              fontSize: rem(14),
              lineHeight: rem(22),
              fontWeight: 400,
              "& + dd": {
                marginTop: rem(22),
              },
            },
          },
          "& .btn-link": {
            marginTop: rem(30),
            zIndex: 1,
            "& .link-outlined": {
              fontSize: rem(14),
              color: theme.palette.common.white,
              borderColor: "#bebebe",
              padding: `0 ${rem(50)}`,
              height: rem(40),
              lineHeight: rem(40),
            },
          },
          "&:after": {
            content: "''",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.6)",
          },
          "&:nth-child(1)": {
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/img/studio01.png)`,
          },
          "&:nth-child(2)": {
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/img/studio02.png)`,
          },
          "&:nth-child(3)": {
            backgroundImage: `url(${
              process.env.PUBLIC_URL
            }/images/img/studio03.png)`,
          },
          "&.last-slide.swiper-slide-active": {},
        },
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
      "& .swiper-pagination": {
        position: "absolute",
        left: rem(16),
        top: rem(26),
        bottom: "auto",
        right: "auto",
        zIndex: 2,
        transform: "none",
        width: rem(44),
        "&.swiper-pagination-bullets": {
          "& .swiper-pagination-bullet": {
            width: "100%",
            height: "auto",
            opacity: 1,
            margin: 0,
            width: rem(44),
            height: rem(42),
            borderRadius: 0,
            marginBottom: rem(10),
            "&:nth-child(1)": {
              height: rem(34),
              background: `url(${
                process.env.PUBLIC_URL
              }/images/icon/brand-tab01.svg) no-repeat 50% 50%`,
            },
            "&:nth-child(2)": {
              background: `url(${
                process.env.PUBLIC_URL
              }/images/icon/brand-tab02.svg) no-repeat 50% 50%`,
            },
            "&:nth-child(3)": {
              background: `url(${
                process.env.PUBLIC_URL
              }/images/icon/brand-tab03.svg) no-repeat 50% 50%`,
            },
            "&.swiper-pagination-bullet-active": {
              width: "100%",
              "&:nth-child(1)": {
                background: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/brand-tab01-on.svg) no-repeat 50% 50%`,
              },
              "&:nth-child(2)": {
                background: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/brand-tab02-on.svg) no-repeat 50% 50%`,
              },
              "&:nth-child(3)": {
                background: `url(${
                  process.env.PUBLIC_URL
                }/images/icon/brand-tab03-on.svg) no-repeat 50% 50%`,
              },
            },
          },
        },
      },
      "& .swiper-button-prev": {
        display: "none",
      },
      "& .swiper-button-next": {
        width: rem(15),
        height: rem(25),
        bottom: rem(40),
        left: "50%",
        marginLeft: rem(-7),
        display: "block",
        marginTop: "auto",
        "&:after": {
          content: "''",
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/arrow-down.svg)`,
          width: rem(15),
          height: rem(25),
          display: "block",
        },
        "&.swiper-button-disabled": {
          display: "none",
        },
      },
    },
    "& + .MuiModal-root": {
      "& .MuiDialog-container": {
        "transition-duration": "0s !important",
      },
    },
  },
}));
export default function DrawerStudio(props) {
  const { open, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();  

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      className={classes.studio}
    >
      <AppBar>
        <Toolbar>
          <h2 className="h2">스튜디오M</h2>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={handleClose}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Swiper
          direction={"vertical"}
          navigation={true}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          <SwiperSlide>
            <h2>STUDIO M</h2>
            <dl>
              <dt>
                <span>행복을 요리하는</span>메가마트 쿠킹 클래스
              </dt>
              <dd>
                메가마트의 신선하고 건강한 재료로 누구나 쉽게 가정에서 다양한
                음식을 해먹을 수 있도록 맛있고 즐거운 비법을 전수해주는
                공간입니다.
              </dd>
              <dd>
                지금껏 눈으로 보기만 했던 음식을 직접 만들어보며 일상 속 특별한
                경험을 선물받으세요!
              </dd>
            </dl>
          </SwiperSlide>
          <SwiperSlide>
            <dl>
              <dt>강좌 신청</dt>
              <dd>
                메가마트 쿠킹클래스 STUDIO M으로 초대합니다
                <br />
                지금 진행중인 강좌를 확인하세요!
              </dd>
            </dl>
            <div className="btn-link">
              <Link
                // to={{ pathname: "https://www.megamart.com/culture/list/1" }}
                // target="_blank"
                className="link-outlined btn-rounded"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(
                    loadLinkAlert("https://www.megamart.com/culture/list/1")
                  );
                }}
              >
                바로가기
              </Link>
            </div>
          </SwiperSlide>
          <SwiperSlide className="last-slide">
            <dl>
              <dt>수강 후기</dt>
              <dd>
                다른 수강생들이 전해주는
                <br />
                생생한 수강 후기를 만나보세요!
              </dd>
            </dl>
            <div className="btn-link">
              <Link
                // to={{ pathname: "https://www.megamart.com/culture/review" }}
                // target="_blank"
                className="link-outlined btn-rounded"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(
                    loadLinkAlert("https://www.megamart.com/culture/review")
                  );
                }}
              >
                바로가기
              </Link>
            </div>
          </SwiperSlide>
        </Swiper>
      </DialogContent>
    </Dialog>
  );
}
